module.exports = require('./timezones.json');


/*****************
 ** WEBPACK FOOTER
 ** ../~/google-timezones-json/index.js
 ** module id = 1844
 ** module chunks = 3
 **/